import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import './Loader.scss'

// Custom Loading
const Loader = () => {
  return (
    <div className="loaderContainer">
      <Spin />
    </div>
  )
}

export default Loader
